import {
  Bell,
} from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/Button/Button';
import { RevealItem } from 'shared/components/RevealItem/RevealItem';
import { PODCAST_PROVIDERS } from 'shared/data/podcastProviders';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';
import { PodcastProviderCard } from '../components/PodcastProviderCard/PodcastProviderCard';
import { ALLOW_SUBSCRIPTIONS } from 'shared/constants/common';
import { cn } from 'shared/utils/cn';

interface Props {
  title?: string,
  padding?: 'default' | 'tight',
  as?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
}

export function ListenEverywhere({title, padding, as: Heading = 'h2'}:Props) {
  const { t } = useTranslation('home');
  const heading = useScrollReveal({ animation: 'float-up' });
  const subscribe = useScrollReveal({ animation: 'fade', delay: 200 });
  const resolvedTitle = title ?? t('listenEverywhere.title');

  return (
    <section className={cn("px-6 lg:px-24 bg-surface text-center overflow-hidden", padding === 'tight' ? 'py-12' : 'py-16 md:py-32')}>
      <div className="max-w-7xl mx-auto">
        <Heading ref={heading.ref} style={heading.style} className="font-serif text-3xl md:text-4xl mb-10 md:mb-16">
          {resolvedTitle}
        </Heading>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {PODCAST_PROVIDERS.map((provider, i) => (
            <RevealItem key={provider} index={i} animation="fade">
              <PodcastProviderCard provider={provider} />
            </RevealItem>
          ))}
        </div>

        {ALLOW_SUBSCRIPTIONS ? <div ref={subscribe.ref} style={subscribe.style} className="mt-12 md:mt-24 inline-flex flex-wrap items-center gap-4 px-8 py-4 bg-surface-container-highest/30 rounded-full border border-outline-variant/10">
          <Bell size={20} className="text-tertiary" />
          <span className="font-sans italic text-sm sm:text-base">
            {t('listenEverywhere.subtitle')}
          </span>
          <Button variant="gold" size="sm" className="ml-4">
            {t('listenEverywhere.subscribe')}
          </Button>
        </div> : null}
      </div>
    </section>
  );
}
